import {Box, Icon} from "@mui/material";
import * as React from "react";

export default function PGDeleteIconOrange(props: any) {
    return (
        <Icon {...props}>
            <Box component={"img"} alt="edit icon" sx={{display: "block", margin: "2px 0 auto auto"}}
                 src="https://members.performancegolf.com/wp-content/uploads/2025/12/trash-orange.png"/>
        </Icon>
    );
}